import React, { useEffect, useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { log } from "console";
import { FILEURL } from "../../../config/cacheKey";
import { useQuery, useQueryClient } from "react-query";

export default function PdfComponent(props: any) {
    const useQuery = useQueryClient();
    let oldFileUrl = useQuery.getQueryData(FILEURL);
    const [pages, setPages] = useState<number | undefined>(undefined);
    let k: number;

    function update(url: string, pageNumber: number) {
        setPages(pageNumber);
        useQuery.setQueryData(FILEURL, url)
    }

    return (
        <>
            <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
                <Document
                    file={{ url: props.fileDocument }}
                    onLoadSuccess={(pages == undefined && oldFileUrl != props.fileDocument) ? (numPages: any) =>
                        <> {update(props.fileDocument, numPages._pdfInfo.numPages)} </>
                        : (numPages: any) => undefined
                    }
                >
                    {oldFileUrl == props.fileDocument ?
                        <>
                            {Array.from({ length: ((pages != undefined) ? pages : 0) }).map((element: any, index: number) =>
                                <>
                                    < Page pageNumber={index + 1} />
                                </>
                            )
                            }
                        </>
                        : <></>
                        // : ""
                    }
                </Document >
            </div >
        </>
    );
}
